import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '../sass/main.scss'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#485cc7',
        secondary: '#f2f3f5',
        accent: '#82B1FF',
        error: '#e56a54',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
      options: {
        customProperties: true
      }
    }
  },
  icons: {
    iconfont: 'fa'
  }
})
